<template>
    <div>
        <header>
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.7.2/css/all.css" integrity="sha384-fnmOCqbTlWIlj8LyTjo7mOUStjsKC4pOpQbqyi7RrhN7udi9RwhKkMHpvLbHG9Sr" crossorigin="anonymous">

            <nav class="navbar is-transparent" role="navigation" aria-label="main navigation">
                <div class="navbar-brand">
                <a class="navbar-item" href="/">
                    <!-- <img src="@/assets/novicell-logo.png" width="90" height=""> -->
                    <img src="@/assets/Novicell-logo-2018-white-cmyk.png" width="90" height="">
                </a>

                <!-- <span id="main-title">Digital Marketing Tools</span> -->
                <span id="main-title">{{ title }}</span>

                <a role="button" :class="{'is-active': isActive}" @click="toggle()" class="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
                </div>
                <div id="navbarBasicExample" :class="{'is-active': isActive}" @click="toggle()" class="navbar-menu">
                <div class="navbar-start"> </div>

                <div class="navbar-end">

                    <div class="navbar-item has-dropdown is-hoverable">
                    <a class="navbar-link">
                        Tools
                    </a>

                    <div class="navbar-dropdown is-right">
                        <a class="navbar-item">
                        <router-link to="/">🏠Home</router-link>
                        </a>
                        <hr class="navbar-divider">
                        <a class="navbar-item">
                        <router-link to="/ppc1">👍PPC suitability check</router-link>
                        </a>
                        <a class="navbar-item">
                        <router-link to="/ppc2">🚀PPC budget tool</router-link>
                        </a>
                        <a class="navbar-item">
                        <router-link to="/seo">💸SEO ROI tool</router-link>
                        </a>
                        <hr class="navbar-divider">
                        <a class="navbar-item">
                        <router-link to="/about">About</router-link>
                        </a>
                    </div>
                    </div>

                </div>
                </div>
            </nav>
        </header>
    </div>
</template>

<script>
export default {
  props: ['title'],
  data () {
    return {
      isActive: false,
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
    }
  }
}
</script>

<style scoped>

#main-title {
    margin: auto;
    width: 50%;
    min-width: 400px;
    padding-left: 10rem;
    font-size: 1.8rem;
    font-weight: 400;
    color: white
}

.navbar-brand, .navbar-tabs {
    background-color: #B82748;
}
.navbar-menu {
    background-color: #B82748;
}

a.navbar-link {
    color: white;
}

a {
    color: #363636
}

</style>
